import { t } from 'i18next';
import keyMirror from 'keymirror';
const shipmentTagSuggestions = () => {
    const raw = [
        'shag',
        'capacity',
        'dryrun',
        'nonotice',
        'container',
        'late',
        'nophone',
        'missedpu',
        'misseddel',
        'wrongaddress',
        'badBOL',
        'truckcancel',
        'poortraining',
        'noupdate',
        'badaddress',
        'baddetail',
        'badtime',
        'khalid',
        'will',
        'lucas',
        'jacqui',
        'edward',
        'lucas',
    ];
    return raw.map((it) => ({ label: t(it.toUpperCase()) }));
};
const customerTagSuggestions = () => {
    const raw = [
        'amazon_pre_notice',
        'disable_autocomplete_stops',
        'shipments_expose_manually',
        'show_load_details_on_warehouse_scanner',
        'edi_invoice_requires_charge_id_and_charge_code',
        'requires_late_early_reason_code',
        'requires_arrival_info',
        'hold_at_dispatch',
        'requires_on_time_reason_code',
        'block_shipment_clones',
        'prompt_for_offsite',
        'require_chassis_at_stop_completion',
        'auto_expose_drayage_shipments',
        'drayage_trailer_moves',
    ];
    return raw.sort().map((it) => ({ label: it }));
};
const carrierTagSuggestions = () => {
    const raw = [
        'drayage-marketplace-pilot',
        'requires_manual_payout_approval',
        'third_party_carrier',
        'marketplace_carrier',
    ];
    return raw.map((label) => ({ label }));
};
export default {
    token_key: 'cargomatic-admin-token',
    refresh_token_key: 'cargomatic-admin-refresh-token',
    user_key: 'cargomatic-admin-user',
    accountAccessModal: '-partner-access-request-modal',
    shipmentTagSuggestions: shipmentTagSuggestions(),
    customerTagSuggestions: customerTagSuggestions(),
    carrierTagSuggestions: carrierTagSuggestions(),
    collectionChangeEvents: 'add remove reset change destroy invalid',
    masterListFilters: 'masterListFilters',
    ActionTypes: keyMirror({
        LOGIN: null,
        RECEIVE_SALES_REPS: null,
        LOGIN_SUCCESS: null,
        LOGIN_FAIL: null,
        EMAIL_SENT: null,
        EMAIL_FAIL: null,
        LOGOUT: null,
        AUTH_CHECK_SUCCESS: null,
        AUTH_CHECK_FAILED: null,
        RECEIVE_ALL_SHIPMENTS: null,
        SELECT_SHIPMENT: null,
        UNWATCH_SHIPMENT: null,
        MUTE_SHIPMENT: null,
        UN_MUTE_SHIPMENT: null,
        SHIPMENT_CANCEL_SUCCESS: null,
        SHIPMENT_CANCEL_FAILURE: null,
        SHIPMENT_CLOSE_SUCCESS: null,
        SHIPMENT_CLOSE_FAILURE: null,
        DECONSOLIDATE: null,
        RECEIVE_AVAILABLE_DRIVERS: null,
        RECEIVE_AUTHORIZED_DRIVERS: null,
        RECEIVE_NEARBY_DRIVERS: null,
        RECEIVE_NEARBY_CARRIER_DRIVERS: null,
        ASSIGN_DRIVER_REQUEST: null,
        ASSIGN_DRIVER_SUCCESS: null,
        ASSIGN_DRIVER_FAIL: null,
        ASSIGN_DRIVER_RESET: null,
        ACCEPT_OFFER_REQUEST: null,
        ACCEPT_OFFER_SUCCESS: null,
        ACCEPT_OFFER_FAIL: null,
        RECEIVE_MUTED_SHIPMENTS: null,
        RECEIVE_WATCHED_SHIPMENTS: null,
        RECEIVE_SELECTED_SHIPMENT: null,
        RECEIVE_SHIPMENT: null,
        RECEIVE_MASS_UPDATE_SUCCESS: null,
        RECEIVE_BULK_TRANSITION_SUCCESS: null,
        RECEIVE_MASS_UPDATE_FAIL: null,
        RECEIVE_TIMELINE_ADD_FAILURE: null,
        BULK_ADD_ACCESSORIALS_REQUEST: null,
        BULK_ADD_ACCESSORIALS_SUCCESS: null,
        BULK_ADD_ACCESSORIALS_FAIL: null,
        EMAIL_DELIVERY_ORDER_FAIL: null,
        BULK_UPDATE_CARRIER_COSTS_REQUEST: null,
        BULK_UPDATE_CARRIER_COSTS_SUCCESS: null,
        BULK_UPDATE_CARRIER_COSTS_FAIL: null,
        DISMISS_ERROR: null,
        RECEIVE_PAYOUT: null,
        RECEIVE_PAYOUTS: null,
        RECEIVE_OFFERS: null,
        RECEIVE_OFFER: null,
        RECEIVE_CREATED_OFFER: null,
        CREATE_OFFER_FAIL: null,
        CREATE_MARKET_ERROR: null,
        UPDATE_MARKET_ERROR: null,
        RECEIVE_CREATE_EXCEPTION: null,
        RECEIVE_EXCEPTION: null,
        RECEIVE_EXCEPTIONS: null,
        ADD_INVOICES: null,
        ADD_PAYOUTS: null,
        WATCH_PAYOUT: null,
        UNWATCH_PAYOUT: null,
        RECEIVE_INVOICE: null,
        RECEIVE_INVOICES: null,
        WATCH_INVOICE: null,
        UNWATCH_INVOICE: null,
        RECEIVE_SHIPMENT_UPDATE: null,
        RECEIVE_SHIPMENT_UPDATE_ERROR: null,
        RECEIVE_SALESPEOPLE: null,
        RECEIVE_USER_PROFILE: null,
        SHIPMENT_NO_LONGER_IN_EXCEPTION: null,
        SHIPMENT_NOW_IN_EXCEPTION: null,
        OFFER_NOW_ACTIVE: null,
        OFFER_NO_LONGER_ACTIVE: null,
        WATCH_OFFER: null,
        UNWATCH_OFFER: null,
        UPDATE_USER_SUCCESS: null,
        UPDATE_USER_FAILURE: null,
        USER_SET_MARKETS_PREFERENCE: null,
        USER_RECEIVE_MARKETS_PREFERENCE: null,
        CUSTOMER_FETCH: null,
        RECEIVE_CUSTOMER_LIST: null,
        CUSTOMERS_FETCH: null,
        SHIPPER_FETCH: null,
        CARRIER_FETCH: null,
        DRIVER_FETCH: null,
        SHIPPERS_FETCH: null,
        CARRIERS_FETCH: null,
        DRIVERS_FETCH: null,
        SEARCH_CUSTOMERS_REQUEST: null,
        SEARCH_CUSTOMERS_SUCCESS: null,
        SEARCH_CUSTOMERS_FAIL: null,
        SEARCH_QUOTES_REQUEST: null,
        SEARCH_QUOTES_SUCCESS: null,
        SEARCH_QUOTES_FAIL: null,
        SHIPPER_UPDATE: null,
        VENDOR_UPDATE: null,
        ADMIN_UPDATE: null,
        UPDATE_ADMIN_FAIL: null,
        UPDATE_ADMIN_SUCCESS: null,
        SHIPPER_UPDATE_COMMENTS: null,
        CARRIER_UPDATE: null,
        DRIVER_UPDATE: null,
        DRIVER_CREATE: null,
        DRIVER_CREATE_FAIL: null,
        UPDATED_CARRIER: null,
        UPDATE_CARRIER_FAILED: null,
        UPDATED_SHIPPER: null,
        UPDATED_VENDOR: null,
        UPDATED_SHIPPER_BILLING: null,
        UPDATE_NOTIFICATIONS_SUCCESS: null,
        UPDATE_NOTIFICATIONS_FAIL: null,
        UPDATE_SHIPPER_FAIL: null,
        UPDATED_DRIVER: null,
        UPDATE_DRIVER_FAILED: null,
        CREATED_CARRIER: null,
        CREATED_DRIVER: null,
        RECEIVE_CUSTOMER: null,
        RECEIVE_SHIPPER: null,
        RECEIVE_SHIPPERS: null,
        RECEIVE_SHIPPER_QUOTES: null,
        FETCH_QUOTE_AFTER_UPDATE: null,
        FETCH_QUOTE_AFTER_UPDATE_SUCCESS: null,
        FETCH_QUOTES_BY_SHIPPER: null,
        RECEIVE_CARRIER: null,
        RECEIVE_CARRIERS: null,
        RECEIVE_CARRIER_RMIS: null,
        RECEIVE_DRIVER_MANIFEST: null,
        RECEIVE_DEPARTED_MANIFEST: null,
        DRIVER_MANIFEST_DEPART_SUCCESS: null,
        DRIVER_MANIFEST_DEPART_FAIL: null,
        DRIVER_MANIFEST_ALREADY_DEPART_ERROR: null,
        RECEIVE_DRIVER: null,
        RECEIVE_DRIVERS: null,
        RECEIVE_CUSTOMER_SEARCH: null,
        ORIGIN_CREATE: null,
        DESTINATION_CREATE: null,
        CREATED_ORIGIN: null,
        CREATED_DESTINATION: null,
        MARKETS_FETCH: null,
        MARKET_FETCH: null,
        FIND_MARKET: null,
        FIND_MARKET_SUCCESS: null,
        FIND_MARKET_FAIL: null,
        RECEIVE_MARKET: null,
        RECEIVE_MARKETS: null,
        CREATE_MARKET_SUCCESS: null,
        CREATE_MARKET_FAIL: null,
        UPDATE_MARKET_SUCCESS: null,
        UPDATE_MARKET_FAIL: null,
        USER_PASSWORD_UPDATE: null,
        UPDATED_USER_PASSWORD: null,
        UPDATED_USER_PASSWORD_FAIL: null,
        PASSWORD_RESET_REQUEST_SUCCESS: null,
        PASSWORD_RESET_REQUEST_FAILURE: null,
        PASSWORD_CHANGE_SUCCESS: null,
        PASSWORD_CHANGE_FAILURE: null,
        CREDIT_CARDS_FETCH: null,
        BANK_ACCOUNTS_FETCH: null,
        CREATE_CREDIT_CARD: null,
        VALIDATE_AND_CREATE_CREDIT_CARD: null,
        VALIDATE_AND_UPDATE_BILLING_ADDRESS: null,
        CREATE_BANK_ACCOUNT: null,
        UPDATED_CREDIT_CARD: null,
        UPDATED_BANK_ACCOUNT: null,
        UPDATE_BANK_ACCOUNT_FAILED: null,
        SAVE_LEGAL_ENTITY: null,
        RECEIVE_CREDIT_CARDS: null,
        RECEIVE_BANK_ACCOUNTS: null,
        PAYOUT_CREATE: null,
        CHARGE_CREATE: null,
        CREATED_PAYOUT: null,
        CREATED_CHARGE: null,
        FAILED_PAYOUT: null,
        FAILED_CHARGE: null,
        INVOICE_CHARGE_CREATE: null,
        PAYOUT_PAYMENT_CREATE: null,
        STRIPE_PAYOUTS_FETCH: null,
        STRIPE_CHARGES_FETCH: null,
        RECEIVE_STRIPE_PAYOUTS: null,
        RECEIVE_STRIPE_CHARGES: null,
        FUND_STRIPE: null,
        STRIPE_FUNDED: null,
        STRIPE_FUNDING_FAILED: null,
        RECEIVE_ADMIN_USERS: null,
        RECEIVE_ADMIN_USER: null,
        RECEIVE_USERS_WITH_TARIFF: null,
        ASSIGN_MASTER_ACCOUNT: null,
        UPDATE_CUSTOMER: null,
        RECEIVE_FREQUENT_SHIPPERS: null,
        RECEIVE_GROWTH_METRICS: null,
        RECEIVE_DAILY_GROWTH_METRICS: null,
        RECEIVE_DAILY_CUSTOMER_METRICS: null,
        RECEIVE_DAILY_LOOKBACK_METRICS: null,
        RECEIVE_TARIFF: null,
        RECEIVE_TARIFFS: null,
        ADD_TARIFF_SUCCESS: null,
        UPDATE_TARIFF_SUCCESS: null,
        UPDATE_TARIFF_FAIL: null,
        REMOVE_TARIFF_SUCCESS: null,
        REMOVE_TARIFF_FAIL: null,
        GET_TARIFFS_USAGE: null,
        ASSIGN_TARIFF_SUCCESS: null,
        ASSIGN_TARIFF_FAIL: null,
        UNASSIGN_TARIFF_SUCCESS: null,
        UNASSIGN_TARIFF_FAIL: null,
        GET_PRICE_REQUEST: null,
        GET_PRICE_FAIL: null,
        RECEIVE_PRICE: null,
        RECEIVE_DOCUMENT: null,
        RECEIVE_DOCUMENT_URI_SUCCESS: null,
        RECEIVE_DOCUMENT_URI_FAIL: null,
        CLEAR_DOCUMENTS: null,
        CLEAR_ALL_MESSAGES: null,
        CLEAR_MESSAGE: null,
        RECEIVE_SHIPMENT_DISTANCE_SUCCESS: null,
        LOCATIONS_FETCH: null,
        RECEIVE_LOCATIONS_LIST: null,
        RECEIVE_LOCATION_SEARCH: null,
        RESOLVE_EXCEPTION: null,
        RESOLVE_EXCEPTIONS: null,
        RECEIVE_CONTRACT: null,
        RECEIVE_CONTRACTS: null,
        ADD_CONTRACT_SUCCESS: null,
        UPDATE_CONTRACT_SUCCESS: null,
        UPDATE_CONTRACT_FAIL: null,
        REMOVE_CONTRACT_SUCCESS: null,
        REMOVE_CONTRACT_FAIL: null,
        RECEIVE_TARIFFRATE: null,
        RECEIVE_TARIFFRATES: null,
        ADD_TARIFFRATE_SUCCESS: null,
        UPDATE_TARIFFRATE_SUCCESS: null,
        UPDATE_TARIFFRATE_FAIL: null,
        REMOVE_TARIFFRATE_SUCCESS: null,
        REMOVE_TARIFFRATE_FAIL: null,
        RECEIVE_ACCESSORIALRATE: null,
        RECEIVE_ACCESSORIALRATES: null,
        ADD_ACCESSORIALRATE_SUCCESS: null,
        ADD_ACCESSORIAL_FAIL: null,
        ADD_ACCESSORIAL_SUCCESS: null,
        RECEIVE_ACCESSORIAL_REQUEST_FAIL: null,
        RECEIVE_ACCESSORIAL_REQUEST_SUCCESS: null,
        RECEIVE_ACCESSORIAL_PAGINATED_REQUEST_FAIL: null,
        RECEIVE_ACCESSORIAL_PAGINATED_REQUEST_SUCCESS: null,
        UPDATE_ACCESSORIAL_REQUEST_FAIL: null,
        UPDATE_ACCESSORIAL_REQUEST_SUCCESS: null,
        UPDATE_ACCESSORIALRATE_SUCCESS: null,
        UPDATE_ACCESSORIALRATE_FAIL: null,
        REMOVE_ACCESSORIALRATE_SUCCESS: null,
        REMOVE_ACCESSORIALRATE_FAIL: null,
        DOWNLOAD_EQUIPMENT_CSV: null,
        DOWNLOAD_ORDERS_CSV: null,
        DOWNLOAD_ORDERS_CSV_SUCCESS: null,
        RECEIVE_LOCATIONS: null,
        RECEIVE_LOCATION: null,
        UPDATE_CARRIER_DOCUMENTS: null,
        UPDATE_CARRIER_DOCUMENTS_SUCCESS: null,
        UPDATE_CARRIER_DOCUMENTS_FAIL: null,
        SHIPMENTS_SEARCH: null,
        MARKETS_FILTERED: null,
        PROJECT_FILTERED: null,
        TOGGLE_DRIVER_AUTHORIZATION_SUCCESS: null,
        TOGGLE_RECEIVE_OFFERS_SUCCESS: null,
        TOGGLE_MULTIPLE_PICKUP_SUCCESS: null,
        REQUEST_VALIDATE_NEW_DRIVER: null,
        HIDE_ADD_DRIVER_FORM: null,
        SHOW_ADD_DRIVER_FORM: null,
        CREATE_DRIVER_SUCCESS: null,
        CREATE_DRIVER_FAIL: null,
        CREATE_DEFAULT_DRIVER: null,
        CREATE_DEFAULT_DRIVER_SUCCESS: null,
        CREATE_DEFAULT_DRIVER_FAIL: null,
        GET_ACTIVE_JOBS: null,
        GET_ACTIVE_SHIPMENTS: null,
        RECEIVE_ACTIVE_SHIPMENTS: null,
        DRIVER_MARKER_CLICKED: null,
        CLOSE_DRIVER_JOBS_LIST: null,
        OPEN_TRACKING_SHIPMENT: null,
        CLOSE_TRACKING_SHIPMENT: null,
        SHARE_SHIPMENT: null,
        RECEIVE_SHARE_SHIPMENT: null,
        UPLOAD_SHIPMENT_DOCUMENT_SUCCESS: null,
        UPLOAD_SHIPMENT_DOCUMENT_FAIL: null,
        RECEIVE_SHIPMENT_AUDIT: null,
        RECEIVE_DRIVER_WAYPOINTS: null,
        RECEIVE_ALL_EQUIPMENT: null,
        ADD_EQUIPMENT: null,
        UPDATE_EQUIPMENT_FAIL: null,
        UPDATE_EQUIPMENT: null,
        BULK_UPDATE_EQUIPMENTS_FAIL: null,
        BULK_UPDATE_EQUIPMENTS: null,
        ADD_EQUIPMENT_FAIL: null,
        FETCH_ORDERS_REQUEST: null,
        FETCH_ORDERS_SUCCESS: null,
        FETCH_ORDERS_FAIL: null,
        FETCH_ORDER_REQUEST: null,
        FETCH_ORDER_SUCCESS: null,
        FETCH_ORDER_FAIL: null,
        FETCH_ORDER_AUDITS: null,
        FETCH_ORDER_AUDIT_SUCCESS: null,
        FETCH_EQUIPMENT_AUDIT_SUCCESS: null,
        FETCH_ORDER_TEMPLATES_REQUEST: null,
        FETCH_ORDER_TEMPLATES_SUCCESS: null,
        FETCH_ORDER_TEMPLATES_FAIL: null,
        TRANSITION_ORDER_REQUEST: null,
        TRANSITION_ORDER_FAIL: null,
        TRANSITION_ORDER_SUCCESS: null,
        CREATE_ORDER_REQUEST: null,
        CREATE_ORDER_SUCCESS: null,
        CREATE_ORDER_FAIL: null,
        CREATE_ORDER_SHIPMENT_REQUEST: null,
        CREATE_ORDER_SHIPMENT_SUCCESS: null,
        CREATE_ORDER_SHIPMENT_FAIL: null,
        CREATE_SHIPMENT_FROM_ORDER_REQUEST: null,
        CREATE_SHIPMENT_FROM_ORDER_SUCCESS: null,
        CREATE_SHIPMENT_FROM_ORDER_FAIL: null,
        SAVE_TEMPLATE_AND_BOOK_ORDER_REQUEST: null,
        SAVE_TEMPLATE_AND_BOOK_ORDER_SUCCESS: null,
        SAVE_TEMPLATE_AND_BOOK_ORDER_FAIL: null,
        CREATE_ORDER_AND_TEMPLATE_REQUEST: null,
        CREATE_ORDER_AND_TEMPLATE_SUCCESS: null,
        CREATE_ORDER_AND_TEMPLATE_FAIL: null,
        CANCEL_ORDER_REQUEST: null,
        CANCEL_ORDER_SUCCESS: null,
        CANCEL_ORDER_FAIL: null,
        REOPEN_ORDER_REQUEST: null,
        REOPEN_ORDER_SUCCESS: null,
        REOPEN_ORDER_FAIL: null,
        UPDATE_ORDER_REQUEST: null,
        UPDATE_ORDER_DATES: null,
        UPDATE_ORDER_SUCCESS: null,
        UPDATE_ORDER_FAIL: null,
        UPLOAD_ORDER_DOCUMENT_REQUEST: null,
        UPLOAD_ORDER_DOCUMENT_SUCCESS: null,
        UPLOAD_ORDER_DOCUMENT_FAIL: null,
        DELETE_ORDER_DOCUMENT_REQUEST: null,
        DELETE_ORDER_DOCUMENT_SUCCESS: null,
        DELETE_ORDER_DOCUMENT_FAIL: null,
        ADD_ORDER_EQUIPMENT_REQUEST: null,
        ADD_ORDER_EQUIPMENT_SUCCESS: null,
        ADD_ORDER_EQUIPMENT_FAIL: null,
        ADD_ORDER_COMMENT_REQUEST: null,
        ADD_ORDER_COMMENT_SUCCESS: null,
        ADD_ORDER_COMMENT_FAIL: null,
        REMOVE_ORDER_EQUIPMENT_REQUEST: null,
        REMOVE_ORDER_EQUIPMENT_SUCCESS: null,
        REMOVE_ORDER_EQUIPMENT_FAIL: null,
        CREATE_LOCATION_FAIL: null,
        SAVE_LOCATION_FAIL: null,
        SEND_DELIVERY_ORDER_REQUEST: null,
        SEND_DELIVERY_ORDER_SUCCESS: null,
        SEND_DELIVERY_ORDER_FAIL: null,
        GENERATE_DELIVERY_ORDER_REQUEST: null,
        GENERATE_DELIVERY_ORDER_SUCCESS: null,
        GENERATE_DELIVERY_ORDER_FAIL: null,
        GENERATE_BILL_OF_LADING_SUCCESS: null,
        GENERATE_BILL_OF_LADING_SENT_SUCCESS: null,
        GENERATE_BILL_OF_LADING_FAIL: null,
        GENERATE_RATE_CONFIRMATION_SUCCESS: null,
        GENERATE_RATE_CONFIRMATION_SENT_SUCCESS: null,
        GENERATE_RATE_CONFIRMATION_FAIL: null,
        BOL_CONTACTS_NEEDED: null,
        GENERATE_CUSTOM_DELIVERY_ORDER_REQUEST: null,
        GENERATE_CUSTOM_DELIVERY_ORDER_SUCCESS: null,
        GENERATE_CUSTOM_DELIVERY_ORDER_FAIL: null,
        EMAIL_CUSTOM_DELIVERY_ORDER_REQUEST: null,
        EMAIL_CUSTOM_DELIVERY_ORDER_SUCCESS: null,
        EMAIL_CUSTOM_DELIVERY_ORDER_FAIL: null,
        GENERATE_ORDER_INVOICE_REQUEST: null,
        GENERATE_ORDER_INVOICE_SUCCESS: null,
        GENERATE_ORDER_INVOICE_FAIL: null,
        GENERATE_ORDER_PAYOUT_SUCCESS: null,
        GENERATE_ORDER_PAYOUT_REQUEST: null,
        GENERATE_ORDER_PAYOUT_FAIL: null,
        RECEIVE_UPDATE_JOBS_SHIPPER_SUCCESS: null,
        RECEIVE_UPDATE_JOBS_CARRIER_SUCCESS: null,
        RECEIVE_UPDATE_JOBS_CARRIER_FAIL: null,
        RECEIVE_LOCATION_PAIRS: null,
        RECEIVE_LOCATION_PAIRS_FAIL: null,
        RECEIVE_CREATE_LOCATION_PAIR: null,
        RECEIVE_CREATE_LOCATION_PAIR_FAIL: null,
        RECEIVE_UPDATE_LOCATION_PAIR: null,
        RECEIVE_UPDATE_LOCATION_PAIR_FAIL: null,
        RECEIVE_DELETE_LOCATION_PAIR: null,
        RECEIVE_DELETE_LOCATION_PAIR_FAIL: null,
        RECEIVE_DELETE_LOCATION: null,
        RECEIVE_DELETE_LOCATION_FAIL: null,
        ORDERS_SEARCH_BY_QUERY_REQUEST: null,
        ORDERS_SEARCH_SUCCESS: null,
        ORDERS_SEARCH_FAIL: null,
        UPDATE_SHIPMENT_ADJUSTMENTS_SUCCESS: null,
        SET_DRIVER_SUCCESS: null,
        SET_DRIVER_FAIL: null,
        GET_ALL_FILTERS_SUCCESS: null,
        FILTERS_FAILURE: null,
        FILTER_DELETED: null,
        FILTER_CREATED: null,
        GRID_UPDATE: null,
        REGENERATE_INVOICE_SUCCESS: null,
        REGENERATE_INVOICE_FAIL: null,
        UPDATE_INVOICE_SUCCESS: null,
        UPDATE_INVOICE_FAIL: null,
        UV_DATE_UPDATE: null,
        SET_UV_DATE_TO: null,
        SET_UV_DATE_FROM: null,
        GET_SHIPMENTS_BY_ID: null,
        CREATE_TRIP_REQUEST: null,
        CREATE_TRIP_SUCCESS: null,
        CREATE_TRIP_FAIL: null,
        UPDATE_TRIP_REQUEST: null,
        UPDATE_TRIP_SUCCESS: null,
        UPDATE_TRIP_FAIL: null,
        GET_TRIPS_REQUEST: null,
        GET_TRIPS_SUCCESS: null,
        GET_TRIPS_FAIL: null,
        SAVE_AND_APPLY_TRIP_REQUEST: null,
        SAVE_AND_APPLY_TRIP_SUCCESS: null,
        SAVE_AND_APPLY_TRIP_FAIL: null,
        GENERATE_TRIP_REQUEST: null,
        GENERATE_TRIP_SUCCESS: null,
        GENERATE_TRIP_FAIL: null,
        UPDATE_STOP_EQUIPMENTS_SUCCESS: null,
        UPDATE_STOP_EQUIPMENTS_FAIL: null,
        ADD_EQUIPMENT_FOR_STAGING_STOP_REQUEST: null,
        ADD_EQUIPMENT_FOR_STAGING_STOP_SUCCESS: null,
        ADD_EQUIPMENT_FOR_STAGING_STOP_FAIL: null,
        FETCH_ORDER_SHIPMENTS_REQUEST: null,
        FETCH_ORDER_SHIPMENTS_SUCCESS: null,
        FETCH_ORDER_SHIPMENTS_FAIL: null,
        RESET_ORDER_SHIPMENTS: null,
        RESET_STAGING_SHIPMENTS: null,
        RECEIVE_SHIPMENT_STOP_COMPLETE_SUCCESS: null,
        RECEIVE_SHIPMENT_STOP_COMPLETE_FAILURE: null,
        UPDATE_EXCEPTION: null,
        UPDATE_EXCEPTION_FAIL: null,
        CREATE_QUOTE_REQUEST: null,
        CREATE_QUOTE_SUCCESS: null,
        CREATE_QUOTE_FAIL: null,
        UPDATE_QUOTE_REQUEST: null,
        UPDATE_QUOTE_SUCCESS: null,
        UPDATE_QUOTE_FAIL: null,
        DELETE_QUOTE_REQUEST: null,
        DELETE_QUOTE_SUCCESS: null,
        DELETE_QUOTE_FAIL: null,
        FETCH_QUOTE_REQUEST: null,
        FETCH_QUOTE_SUCCESS: null,
        FETCH_QUOTE_FAIL: null,
        UPDATE_ACCESSORIAL_EXCEPTION_SUCCESS: null,
        UPDATE_ACCESSORIAL_EXCEPTION_FAIL: null,
        REMOVE_FAVORITE_LOCATION_REQUEST: null,
        REMOVE_FAVORITE_LOCATION_SUCCESS: null,
        REMOVE_FAVORITE_LOCATION_FAIL: null,
        TRANSITION_SHIPMENT_SUCCESS: null,
        TRANSITION_SHIPMENT_FAIL: null,
        REMOVE_CARRIER: null,
        SHARE_SHIPMENT_SUCCESS: null,
        SHARE_SHIPMENT_FAIL: null,
        BULK_UPDATE_DATES_SUCCESS: null,
        BULK_UPDATE_DATES_FAIL: null,
        BULK_UPDATE_NOTES_SUCCESS: null,
        BULK_UPDATE_NOTES_FAIL: null,
        BULK_UPDATE_SHIPMENTS_SUCCESS: null,
        BULK_UPDATE_SHIPMENTS_FAIL: null,
        BULK_UPDATE_REFERENCE_SUCCESS: null,
        BULK_UPDATE_REFERENCE_FAIL: null,
        UPSERT_ACI_ZONES_SUCCESS: null,
        UPSERT_ACI_ZONES_FAIL: null,
        GET_COLUMN_SET: null,
        ERROR_COLUMN_SET: null,
        CREATE_COLUMN_SET: null,
        UPDATE_COLUMN_SET: null,
        DELETE_COLUMN_SET: null,
        GET_CUSTOMERS_FAIL: null,
        DOWNLOAD_CUSTOMERS_CSV_FAIL: null,
        FETCH_CUSTOMER_AUDITS: null,
        FETCH_CUSTOMER_AUDITS_SUCCESS: null,
        FETCH_CUSTOMER_AUDITS_FAIL: null,
        CREATE_ACCESSORIAL_REQUEST_SUCCESS: null,
        CREATE_ACCESSORIAL_REQUEST_FAIL: null,
        ACCEPT_ACCESSORIALS_SUCCESS: null,
        ACCEPT_ACCESSORIALS_FAIL: null,
        BULK_CREATE_ACCESSORIAL_REQUEST_SUCCESS: null,
        BULK_CREATE_ACCESSORIAL_REQUEST_FAIL: null,
        APPROVE_ACCESSORIALS_SUCCESS: null,
        APPROVE_ACCESSORIALS_FAIL: null,
        DECLINE_ACCESSORIALS_SUCCESS: null,
        DECLINE_ACCESSORIALS_FAIL: null,
        UPDATE_DELIVERY_ORDER_STATUS_SUCCESS: null,
        UPDATE_DELIVERY_ORDER_STATUS_FAIL: null,
        UPLOAD_ACCESSORIAL_DOC_FAIL: null,
        UPLOAD_ACCESSORIAL_DOC_SUCCESS: null,
        RECEIVE_DRAYAGE_OFFER_SUCCESS: null,
        RECEIVE_DRAYAGE_OFFER_FAIL: null,
        CLEAR_LOCATION: null,
        UPDATE_SHIPPER_INVOICE_DOCUMENT_PREFERENCES: null,
        UPDATE_SHIPPER_FSC_CONFIG: null,
        RERATE_SHIPMENT_COSTS_SUCCESS: null,
        RERATE_SHIPMENT_COSTS_FAILURE: null,
        RECEIVE_UPDATE_JOBS_CONSIGNEE_SUCCESS: null,
        RECEIVE_UPDATE_JOBS_CONSIGNEE_FAIL: null,
        RECEIVE_SHIPMENT_CLONE_SUCCESS: null,
        ADD_CARRIER_PORTPRO_DATA: null,
        ADDED_CARRIER_PORTPRO_DATA: null,
        ADD_CARRIER_PORTPRO_DATA_FAILED: null,
        CHANGE_PORTPRO_ENABLING: null,
        CHANGED_PORTPRO_ENABLING: null,
        CHANGE_PORTPRO_ENABLING_FAILED: null,
        SAVE_PORTPRO_INTEGRARION: null,
        SAVE_PORTPRO_INTEGRARION_FAILED: null,
    }),
    PayloadSources: keyMirror({
        SERVER_ACTION: null,
        VIEW_ACTION: null,
    }),
};
